module.exports = __webpack_public_path__ + "img/yellow-rectangle.svg";